export default "__VITE_ASSET__B98iyYkK__"